import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export interface ToastEvent {
  type: ToastEventTypes;
  title: string;
  message: string;
}

export enum ToastEventTypes {
  Success = 'success',
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
}

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  toastEvents: Observable<ToastEvent>;
  private _toastEvents = new Subject<ToastEvent>();

  constructor() {
    this.toastEvents = this._toastEvents.asObservable();
  }

  /**
   * Show success toast notification.
   * @param title Toast title
   * @param message Toast message
   */
  showSuccessToast(message: string, title: string = 'SUCCESS') {
    this._toastEvents.next({
      message,
      title,
      type: ToastEventTypes.Success,
    });
  }

  /**
   * Show info toast notification.
   * @param title Toast title
   * @param message Toast message
   */
  showInfoToast(message: string, title: string = 'INFO') {
    this._toastEvents.next({
      message,
      title,
      type: ToastEventTypes.Info,
    });
  }

  /**
   * Show warning toast notification.
   * @param title Toast title
   * @param message Toast message
   */
  showWarningToast(message: string,  title: string = 'WARNING') {
    this._toastEvents.next({
      message,
      title,
      type: ToastEventTypes.Warning,
    });
  }

  /**
   * Show error toast notification.
   * @param title Toast title
   * @param message Toast message
   */
  showErrorToast( message: string, title: string = 'ERROR!') {
    this._toastEvents.next({
      message,
      title,
      type: ToastEventTypes.Error,
    });
  }
}